const primaryThemeGradient =
  'linear-gradient( 310deg, var(--chakra-colors-primaryThemeColour-500) 0%, var(--chakra-colors-primaryThemeColour-500) 30%, var(--chakra-colors-primaryThemeColour-400) 100% );';

const primaryThemeGradientDark =
  'linear-gradient( 310deg, var(--chakra-colors-primaryThemeColour-500) 0%, var(--chakra-colors-primaryThemeColour-500) 50%, var(--chakra-colors-primaryThemeColour-400) 100% );';

const base2ColourGradient =
  'linear-gradient(250deg,var(--chakra-colors-base2Colour-400),var(--chakra-colors-base2Colour-400) 5%,rgba(84,84,84,.6) 40%,rgba(84,84,84,.6) 80%)';

const gradientStyle = {
  bg: 'linear-gradient( 310deg, var(--chakra-colors-secondaryThemeColour-500) 0%, var(--chakra-colors-secondaryThemeColour-500) 30%, var(--chakra-colors-secondaryThemeColour-400) 100% );',
  _hover: {
    bg: 'linear-gradient( 310deg, var(--chakra-colors-secondaryThemeColour-500) 0%, var(--chakra-colors-secondaryThemeColour-500) 50%, var(--chakra-colors-secondaryThemeColour-400) 100% );',
    _disabled: {
      bg: 'linear-gradient( 310deg, var(--chakra-colors-secondaryThemeColour-500) 0%, var(--chakra-colors-secondaryThemeColour-500) 50%, var(--chakra-colors-secondaryThemeColour-400) 100% );',
    },
  },
};

const tertiaryThemeGradient =
  'linear-gradient( 310deg, var(--chakra-colors-tertiaryThemeColour-500) 0%, var(--chakra-colors-tertiaryThemeColour-500) 30%, var(--chakra-colors-tertiaryThemeColour-400) 100% );';

const tertiaryThemeGradientDark =
  'linear-gradient( 310deg, var(--chakra-colors-tertiaryThemeColour-500) 0%, var(--chakra-colors-tertiaryThemeColour-500) 50%, var(--chakra-colors-tertiaryThemeColour-400) 100% );';

const secondaryThemeGradient =
  'linear-gradient( 310deg, var(--chakra-colors-secondaryThemeColour-500) 0%, var(--chakra-colors-secondaryThemeColour-500) 30%, var(--chakra-colors-secondaryThemeColour-400) 100% );';

const secondaryThemeGradientDark =
  'linear-gradient( 310deg, var(--chakra-colors-secondaryThemeColour-500) 0%, var(--chakra-colors-secondaryThemeColour-500) 50%, var(--chakra-colors-secondaryThemeColour-400) 100% );';

export {
  gradientStyle,
  primaryThemeGradient,
  primaryThemeGradientDark,
  secondaryThemeGradient,
  secondaryThemeGradientDark,
  tertiaryThemeGradient,
  tertiaryThemeGradientDark,
  base2ColourGradient,
};
